




























import { Component, Prop } from 'vue-property-decorator'

import {
  SuccessChannelInfo,
  ErrorChannelInfo
} from "../../../../../../../../../../../models/CheckChannels/CheckChannels";
import { VueComponent } from '../../../../../../../../../../../shared/types/VueComponent';
import { PlaceholdersOnes } from '../../../../../../../../../../Editor/components/Toolbar/types'
import {
  AvailableButtonsTypes
} from '../../../../../../../../../../MessageEditorWithMedia/components/ButtonsConstructor/types'
import MessageEditorWithMediaData
  from '../../../../../../../../../../NewMessageEditors/NewMessageEditorWithMedia/types'
import { UseFields } from '../../../../../../../../../../Pi'
import TargetCard from '../../../../../../../../../../TargetCard/TargetCard.vue'
import { TargetCardInfo } from '../../../../../../../../../../TargetCard/types'
import CustomEditor from '../../../../../../../Editor/CustomEditor'
import { ActionNode } from '../../../../logic/ActionNode'
import {
  NotifyGroupActionProxy
} from '../../../../logic/Actions/NotifyGroupAction/NotifyGroupActionProxy'
import { ActionNodeProps } from '../../../../logic/types'
import NotifyGroupActionChannelCard from './components/NotifyGroupActionChannelCard.vue'
import NotifyGroupActionMessageSettings from './components/NotifyGroupActionMessageSettings.vue'
import NotifyGroupActionSetChannelField from './components/NotifyGroupActionSetChannelField.vue'

@Component({
  components: {
    NotifyGroupActionChannelCard,
    NotifyGroupActionSetChannelField,
    NotifyGroupActionMessageSettings,
    TargetCard
  },
})
export default class NotifyGroupAction extends UseFields {
  @Prop() action!: NotifyGroupActionProxy

  @Prop() editor!: CustomEditor

  @Prop() node!: ActionNode

  @Prop() availableButtonsTypes!: AvailableButtonsTypes

  @Prop() buttonsHelpView!: VueComponent | string

  @Prop() placeholders!: PlaceholdersOnes

  @Prop() creatingOutputs!: boolean

  @Prop() board!: string

  @Prop() targetOptions!: ActionNodeProps['targetOptions']

  @Prop() usersOptions!: ActionNodeProps['usersOptions']

  get beautifiedTarget(): TargetCardInfo | null {
    const { channelInfo } = this.action

    if (channelInfo) {

      return {
        error: channelInfo instanceof ErrorChannelInfo ? channelInfo.error : null,
        title: channelInfo instanceof SuccessChannelInfo ? channelInfo.info.title : channelInfo.value,
        type: channelInfo instanceof SuccessChannelInfo ? channelInfo.info.type.toLowerCase() : null,
        id: channelInfo instanceof SuccessChannelInfo ? channelInfo.info.id : null,
        login: channelInfo instanceof SuccessChannelInfo ? channelInfo.info.login : null,
        key: channelInfo instanceof SuccessChannelInfo ? channelInfo.info.id : channelInfo!.value,
      }
    }

    return null
  }

  setMessage(messages: Array<MessageEditorWithMediaData>): void {
    this.action.setMessages(messages, this.creatingOutputs, this.node, this.editor)
  }

  get editorTopics() {
    if (
      this.action.action.variants.some(value => value?.topics?.length) ||
      this.action.channelInfo instanceof SuccessChannelInfo && this.action.channelInfo.info.type === 'FORUM'
    ) {
      return { 'topics': { items: [], limit: 1 } }
    }

    return null
  }
}
